import { makeTypes, asyncMac, createReducer, reduceReducers } from 'ducks-maker'
import { createFetch } from './hors.js'
import { crearArchivo } from '../services/api'

const t = makeTypes('archivo')
const FETCH = t('fetch').async()
 
const fetchActions = asyncMac(FETCH)

const initialState = {
    data: [],
    fetched: false,
    fetching: false,
}

const fetchReducer = createReducer(initialState, createFetch( FETCH ))

export default reduceReducers(fetchReducer)

export const asignarArchivo = values => async (dispatch, getState) => {
    dispatch(fetchActions.start())
    try {
        const data = await crearArchivo('/subirCotizacion', values)
        dispatch(fetchActions.success(data))
        return data
    } catch (error) {
        dispatch(fetchActions.error(error))
    }
}

export const agregarAdjuntoItemRecurso = values => async (dispatch, getState) => {
    dispatch(fetchActions.start());
    try {
        const data = await crearArchivo('/subirAdjuntoItemRecurso', values)
        dispatch(fetchActions.success(data));
        return data;
    } catch (error) {
        dispatch(fetchActions.error(error));
    }
}
